import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { switchUserDatabase } from './db/index';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import ForgotPassword from './components/ForgotPassword';
import Dashboard from './components/Dashboard';
import GridMapProApp from './GridMapProApp';
import LandingPage from './components/LandingPage';

console.log('App component loading...');

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      console.log('Setting up auth state listener...');
      const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        console.log('Auth state changed:', currentUser ? 'User logged in' : 'No user');
        
        // Switch to user-specific database when auth state changes
        try {
          await switchUserDatabase();
          console.log('Database switched for user:', currentUser?.uid || 'no user');
        } catch (dbError) {
          console.warn('Failed to switch database:', dbError);
          // Don't fail the auth state change for database issues
        }
        
        setUser(currentUser);
        setLoading(false);
      }, (error) => {
        console.error('Auth state change error:', error);
        setError(error);
        setLoading(false);
      });

      return () => unsubscribe();
    } catch (error) {
      console.error('Error in auth setup:', error);
      setError(error);
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[var(--accent-primary)] border-t-transparent"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center">
        <div className="bg-[var(--bg-secondary)] p-6 rounded-lg shadow-lg max-w-md w-full">
          <h2 className="text-[var(--danger)] text-xl font-bold mb-4">Error Initializing App</h2>
          <p className="text-[var(--text-primary)] mb-4">{error.message}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="btn btn-primary w-full"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/signin" element={!user ? <SignIn /> : <Navigate to="/dashboard" />} />
        <Route path="/signup" element={!user ? <SignUp /> : <Navigate to="/dashboard" />} />
        <Route path="/forgot-password" element={!user ? <ForgotPassword /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/signin" />} />
        <Route path="/project/:id" element={user ? <GridMapProApp /> : <Navigate to="/signin" />} />
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App; 